module.exports = __webpack_public_path__ + "img/5_14.489e7b3c.jpg";